import React from 'react'

import { Form, Col } from '_zari/core'

import * as SedeCrud from 'services/sede.service'

const IdSedeDestinoFormGroup = ({ value, onChange }) => {
  const [sedes, setSedes] = React.useState([])

  React.useEffect(() => {
    SedeCrud.obtenerExceptoActual().then(({ data }) => setSedes(data))
  }, [])

  return (
    <Form.Group>
      <Form.Label text='ESTABLECIMIENTO DESTINO' htmlFor='select-sedeDestino' md={4} />
      <Col md={8}>
        <Form.Select name='selectSede' value={value} onChange={onChange} id='select-sedeDestino'>
          <option value=''>Seleccionar</option>
          {sedes &&
            sedes.map((val, key) => (
              <option key={key} value={val._id}>
                {val.nombre}
              </option>
            ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdSedeDestinoFormGroup)
